module.exports = __webpack_public_path__ + "img/4-gyts.304f8862.jpg";